<template>
  <div class="hello">
    <searchpanel v-model="searchkey0"></searchpanel>
  </div>
</template>

<script>
import searchpanel from './searchpanel.vue'
export default {
  components: { searchpanel },
  name: 'HelloWorld',
  data () {
    return {
      searchkey0: {}
    }
  },
  watch: {
    searchkey0: function (newVal, oldVal) {
      console.log(newVal)
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/singlefile.vue